/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { StyledQuickFilterComponentDiv } from './index.styles';
// import { ComponentProps } from './../../index.types';
import { renderedData } from '../../organisms/SearchResults/searchResultsMainComponent';
import {
  SearchFacetsList,
  SearchFacetsConstants,
  SearchFacetsListCodes,
  ALL_INCLUSIVE,
} from '../../organisms/SearchResults/index.constant';
import {
  quickFilterListType,
  SearchFacetsResponse,
  // SearchFacetsResponseBuckets,
  SearchStateFilterObj,
} from '../../organisms/SearchResults/store/store.type';
import { SearchActions, getSearchAppliedFilter } from '../../organisms/SearchResults/store/store.action';
import { Button } from '@marriott/mi-ui-library';
import { useConditionalSessionUpdateContext } from '../../hooks';
import { formatNumberByLocale, getLocaleFromDocument } from '../../utils';
import { useConditionalPageContextSERP } from '../../hooks';
import { updateQueryParams } from '../../organisms/SearchResults/lib/helper';
import { VI_LOCALE } from '../../modules/constants/Calendar.constants';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';
import { usePageContext } from '../../context';
import clsx from 'clsx';
import { useConditionalSearchFilterContextWithSerpFlag } from '../../hooks/lib/useConditionalSearchFilterContext';
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const QuickFiltersComponent: React.FC<{
  filterData?: Array<SearchFacetsResponse>;
  setFetchCurrencyConversionFactors: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ filterData, setFetchCurrencyConversionFactors }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { jsonContent, setFeatureSelected }: any = useConditionalSearchResultsRenderedDataSERP(renderedData);
  const quickFilters = jsonContent?.quickFilterListArray;
  const clickTrackingLoc = 'Phoenix Search Results';
  const { pageVal } = usePageContext();
  const { currentLocale, headersData } = useConditionalPageContextSERP();
  const { searchQueryState, setSearchQuery } = useConditionalSearchFilterContextWithSerpFlag();
  const { interactionsSelected, setInteractionsSelected } = useConditionalSessionUpdateContext();
  // const getCurrentFilterArray = (): SearchFacetsResponse => {
  //   return searchQueryState?.filter?.filter((key) => key.type.code === SearchFacetsList.amenities)[0];
  // };
  // const [currAvailableAmenities] = useState<SearchFacetsResponse>(getCurrentFilterArray());
  const [currCheckedAmenitiesCode, setCurrCheckedAmenitiesCodeObj] = useState<SearchStateFilterObj | undefined>(
    searchQueryState[SearchFacetsList.amenities] ?? undefined
  );

  const [currCheckedPropertyType, setCurrCheckedPropertyTypeObj] = useState<SearchStateFilterObj | undefined>(
    searchQueryState[SearchFacetsList.propertyType] ?? undefined
  );

  const getCurrentFilterArray = (): SearchFacetsResponse => {
    // update amenties
    return filterData
      ? filterData?.filter((key: any) => key.type.code === SearchFacetsListCodes.amenities)[0]
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any
        searchQueryState?.filter?.filter((key: any) => key.type.code === SearchFacetsListCodes.amenities)[0];
  };

  const getCurrentFilterPropertyTypeArray = (): SearchFacetsResponse => {
    //update property types
    return filterData
      ? filterData?.filter((key: any) => key.type.code === SearchFacetsListCodes.propertyType)[0]
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any
        searchQueryState?.filter?.filter((key: any) => key.type.code === SearchFacetsListCodes.propertyType)[0];
  };

  const [currAvailableAmenties, setCurrAvailableAmenties] = useState<SearchFacetsResponse | undefined>(
    searchQueryState?.filter?.filter((key: any) => key.type.code === SearchFacetsListCodes.amenities)[0]
  );

  const [currAvailablePropertyTypes, setCurrAvailablePropertyTypes] = useState<SearchFacetsResponse | undefined>(
    searchQueryState?.filter?.filter((key: any) => key.type.code === SearchFacetsListCodes.propertyType)[0]
  );

  const [currQuickFilters, setCurrQuickFilters] = useState<Array<quickFilterListType>>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const quickFilterClick = (amenity: any): void => {
    setFeatureSelected(true);
    setFetchCurrencyConversionFactors(true);

    // Determine if the clicked item is a property type or amenity
    const isPropertyType = amenity.code === ALL_INCLUSIVE;

    // Handle property types separately from amenities
    const amenitiesObj: SearchStateFilterObj = { ...currCheckedAmenitiesCode };
    const propertyTypesObj: SearchStateFilterObj = { ...currCheckedPropertyType };

    if (isPropertyType) {
      // Toggle property type
      if (amenity.code in propertyTypesObj) {
        delete propertyTypesObj[amenity.code];
      } else {
        propertyTypesObj[amenity.code] = amenity.code;
      }
    } else {
      // Toggle amenity
      if (amenity.code in amenitiesObj) {
        delete amenitiesObj[amenity.code];
      } else {
        amenitiesObj[amenity.code] = amenity.code;
      }
    }

    // Update the selected amenities filter values in the URL
    const amenities = Object.values(amenitiesObj);
    const propertyTypes = Object.values(propertyTypesObj);
    updateQueryParams(
      {
        amenities,
        hotelTypes: propertyTypes,
      },
      ['amenities', 'hotelTypes'],
      headersData?.referer
    );

    setSearchQuery({
      type: SearchActions.updateOtherSearchQueryParam,
      payload: {
        [SearchFacetsConstants.offset]: 0,
      },
    });
    setCurrCheckedAmenitiesCodeObj(amenitiesObj);
    setCurrCheckedPropertyTypeObj(propertyTypesObj);

    const payload = {
      [SearchFacetsList.amenities]: amenitiesObj,
      [SearchFacetsList.propertyType]: propertyTypesObj,
    };

    setSearchQuery({ type: SearchActions.setApplyFilter, payload: payload });
    setSearchQuery({
      type: SearchActions.setQuery,
      payload: {
        [SearchFacetsConstants.facets]: {
          ...searchQueryState.search[SearchFacetsConstants.facets],
          ...getSearchAppliedFilter(payload, searchQueryState),
        },
        [SearchFacetsConstants.options]: {
          ...searchQueryState.search[SearchFacetsConstants.options],
          [SearchFacetsConstants.includeTaxes]: searchQueryState[SearchFacetsConstants.includeTaxes],
          [SearchFacetsConstants.unavailableProperties]: searchQueryState[SearchFacetsConstants.unavailableProperties],
        },
      },
    });
    setInteractionsSelected({ ...interactionsSelected, quickFilters: true });
  };
  const quickFilterAmenities = searchQueryState[SearchFacetsList.amenities];
  const quickFilterPropertyTypes = searchQueryState[SearchFacetsList.propertyType];
  useEffect(() => {
    setCurrCheckedAmenitiesCodeObj(searchQueryState.AMENITIES);
  }, [searchQueryState.AMENITIES]);

  useEffect(() => {
    setCurrCheckedPropertyTypeObj(searchQueryState.PROPERTY_TYPES);
  }, [searchQueryState.PROPERTY_TYPES]);

  useEffect(() => {
    setCurrAvailableAmenties(getCurrentFilterArray());
    setCurrAvailablePropertyTypes(getCurrentFilterPropertyTypeArray());
    setCurrQuickFilters(getQuickFiltersToDisplay());
  }, [searchQueryState.filter]);

  const quickFiltersToBeDisplayed: quickFilterListType[] = [];
  const getQuickFiltersToDisplay = () => {
    if (quickFilters) {
      for (const filter of quickFilters) {
        if (quickFiltersToBeDisplayed.length >= 3) {
          break;
        }

        let count = 0;

        if (filter.amenitiesTagId === ALL_INCLUSIVE) {
          // For 'all-inclusive', check in buckets of type where code is 'property types'
          const propertyTypesItem = searchQueryState.filter.find(item => item.type.code === 'property-types');

          if (propertyTypesItem) {
            const allInclusiveBucket = propertyTypesItem.buckets.find(bucket => bucket.code === ALL_INCLUSIVE);
            count = allInclusiveBucket?.count || 0;
          }
        } else {
          // For other amenities (breakfast, pet-friendly, pool),
          // check in buckets of type where code is 'amenities'
          const amenitiesItem = searchQueryState.filter.find(item => item.type.code === 'amenities');

          if (amenitiesItem) {
            const amenityBucket = amenitiesItem.buckets.find(bucket => bucket.code === filter.amenitiesTagId);
            count = amenityBucket?.count || 0;
          }
        }

        // Add to array if count > 0
        if (count > 0) {
          quickFiltersToBeDisplayed.push(filter);
        }
      }
    }
    return quickFiltersToBeDisplayed;
  };

  return (
    <StyledQuickFilterComponentDiv>
      <div className={clsx(pageVal === 'chat' ? 'quick-filter-container-chat' : 'quick-filter-container')}>
        {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          currQuickFilters?.map((filter: any, idx: number) => {
            const amenity = { code: filter.amenitiesTagId };
            const isSelected =
              (quickFilterAmenities && amenity?.code ? amenity?.code in quickFilterAmenities : false) ||
              (quickFilterPropertyTypes && amenity?.code ? amenity?.code in quickFilterPropertyTypes : false);
            const isVisibleAmenity = currAvailableAmenties?.buckets.filter(k => k.code === amenity?.code);
            const isVisiblePropertyType = currAvailablePropertyTypes?.buckets.filter(k => k.code === amenity?.code);
            // const count=quickFilterAmenities && amenity?.code==filter.code?amenity?.count:0;
            return currQuickFilters && currQuickFilters.length ? (
              <Button
                className={`m-button-primary-inverse t-label-alt-m quick-filter-option-button button-secondary custom_click_track ${
                  isSelected ? 'checked' : ''
                } ${getLocaleFromDocument() === VI_LOCALE ? 'reduced-font' : ''}`}
                key={idx}
                callback={() => quickFilterClick && quickFilterClick(amenity)}
                custom_click_track_value={`${clickTrackingLoc}|  ${jsonContent.filterLabel}: ${filter.amenitiesTagTitle} |internal`}
                buttonCopy={`${filter.amenitiesTagTitle}
                (${
                  filter.amenitiesTagId === ALL_INCLUSIVE
                    ? formatNumberByLocale(isVisiblePropertyType ? isVisiblePropertyType[0]?.count : 0, currentLocale)
                    : formatNumberByLocale(isVisibleAmenity ? isVisibleAmenity[0]?.count : 0, currentLocale)
                })`}
                isTextBeforeChildren={false}
              >
                {isSelected ? <div className="icon icon-check"></div> : ''}
              </Button>
            ) : null;
          })
        }
      </div>
    </StyledQuickFilterComponentDiv>
  );
};
